<template>
  <div style="display: flex; align-items: center;">
    <button v-on="on" @click="show" class="color-preview" :style="{ 'background-color': color }"></button>
    <v-menu
      :position-x="x"
      :position-y="y"
      absolute
      :close-on-content-click="false"
      v-model="visible"
    >
      <v-card>
        <v-color-picker v-model="tmpColor" flat mode="hexa" :hide-mode-switch="true"></v-color-picker>
        <v-divider v-if="recentColors.length > 0"></v-divider>
        <div class="recent-colors">
          <button
            class="color-preview"
            v-for="(color, index) in recentColors"
            :key="index"
            :style="{ 'background-color': color, 'margin-right': '5px' }"
            @click="tmpColor = color"
          ></button>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  components: {},
  data() {
    return {
      tmpColor: "",
      visible: false,
      x: 0,
      y: 0,
      recentColors: JSON.parse(localStorage.getItem("recent-colors") || "[]")
    };
  },
  props: ["color", "on"],
  watch: {
    tmpColor: function(newVar, oldVar) {
      if (!oldVar) return;
      this.$emit("input", newVar);
      this.saveColorToRecents();
    }
  },
  methods: {
    show(e) {
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    saveColorToRecents: debounce(function() {
      if (this.recentColors.indexOf(this.tmpColor) > -1) return;
      this.recentColors.unshift(this.tmpColor);
      if (this.recentColors.length > 9) {
        this.recentColors.pop();
      }
      localStorage.setItem("recent-colors", JSON.stringify(this.recentColors));
    }, 500)
  },
  created() {
    this.tmpColor = this.color || "#FFFFFF";
  }
};
</script>

<style scoped>
.color-preview {
  width: 35px;
  height: 35px;
  border: 1px dashed #000000;
  box-sizing: border-box;
  outline: none;
  -webkit-appearance: none;
  margin-bottom: 5px;
}
.recent-colors {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 5px;
  max-width: 300px;
}
</style>